import React from 'react';
import { Section } from './ui/Section';
export function ProblemAgitation() {
  return <div className="space-y-24 py-12" data-id="element-99">
      <Section data-id="element-100">
        <div className="prose prose-lg prose-brown mx-auto" data-id="element-101">
          <p className="text-xl font-medium text-brown mb-8" data-id="element-102">
            Si tienes 25–34, vives en USA o Canadá, y hablas español,
            probablemente te pasa esto:
          </p>
          <p className="text-lg leading-relaxed mb-8" data-id="element-103">
            Haces un plan grande… y el primer día caótico lo destruye.
            <br data-id="element-104" />
            <br data-id="element-105" />
            No porque seas flojo.
            <br data-id="element-106" />
            <br data-id="element-107" />
            Porque tu plan estaba hecho para tu versión ideal. No para tu vida
            real.
          </p>
        </div>
      </Section>

      <Section className="bg-cream-dark/50 py-12 rounded-3xl" data-id="element-108">
        <h2 className="text-3xl md:text-4xl mb-8 text-center" data-id="element-109">
          Esto no es otro "reto de 30 días"
        </h2>
        <div className="space-y-6 text-lg text-brown/90" data-id="element-110">
          <p data-id="element-111">Los retos te exigen energía que no tienes.</p>
          <p data-id="element-112">
            Te ponen una vara alta… y cuando fallas, te dejan con dos cosas:
          </p>
          <ul className="list-disc pl-6 space-y-2 marker:text-terracotta" data-id="element-113">
            <li data-id="element-114">Cero resultados</li>
            <li data-id="element-115">Y más culpa</li>
          </ul>
          <p className="font-medium text-terracotta text-xl pt-4" data-id="element-116">
            Reset 4 Pilares (30 días) es otra cosa.
          </p>
          <p data-id="element-117">
            Es un sistema construido alrededor de una verdad incómoda: tu vida
            tiene días malos. Y si tu plan no funciona en días malos, entonces
            no es un plan. Es fantasía.
          </p>
        </div>
      </Section>

      <Section data-id="element-118">
        <h2 className="text-3xl md:text-4xl mb-8" data-id="element-119">
          El problema real: no es disciplina
        </h2>
        <div className="space-y-6 text-lg text-brown/90" data-id="element-120">
          <p data-id="element-121">
            La disciplina suena bien en redes. Pero en la vida real, lo que te
            rompe es:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-4" data-id="element-122">
            {['Dormir mal', 'Estrés', 'Pantalla', 'Presión', 'Cero margen', 'Sensación de atraso'].map(item => <div key={item} className="flex items-center space-x-3 bg-white p-4 rounded-lg shadow-sm border border-cream-dark" data-id="element-123">
                <span className="w-2 h-2 rounded-full bg-terracotta" data-id="element-124" />
                <span data-id="element-125">{item}</span>
              </div>)}
          </div>

          <p data-id="element-126">Entonces intentas arreglarlo con fuerza bruta:</p>
          <div className="pl-6 border-l-4 border-terracotta/30 italic text-brown-light space-y-2 py-2" data-id="element-127">
            <p data-id="element-128">"Mañana empiezo el gym"</p>
            <p data-id="element-129">"Mañana dejo el azúcar"</p>
            <p data-id="element-130">"Mañana me levanto temprano"</p>
          </div>

          <p data-id="element-131">
            Y llega un día pesado. Y tu plan muere. Y tú te dices lo de siempre:{' '}
            <span className="font-bold" data-id="element-132">"Soy un desastre."</span>
          </p>

          <p className="text-xl font-serif font-bold text-terracotta pt-4" data-id="element-133">
            No. Solo no tenías un sistema para sobrevivir al día pesado.
          </p>
        </div>
      </Section>
    </div>;
}